import { Ionicons } from "@expo/vector-icons";
import { Button, useThemeProvider } from "@towersystems/roam-common-native";

export interface LllmQuickWinButtonProps {
  onPress?: () => void;
  disabled?: boolean;
  hoverText?: string;
}

export function LllmQuickWinButton({
  onPress,
  disabled,
  hoverText,
}: LllmQuickWinButtonProps) {
  const { colors, spacings } = useThemeProvider();

  return (
    <Button
      size="compact"
      aria-label="open filters"
      onPress={onPress}
      label="AI"
      disabled={disabled}
      style={{ display: "flex" }}
      hoverText={hoverText}
      stackProps={{
        vertical: false,
        centerVertical: true,
        spacing: spacings.s2,
      }}
    >
      <Ionicons name="sparkles" size={17} color={colors.text} />
    </Button>
  );
}
